const IMGSTATION = {
  // "syshead": require('../../../static/img/syscom/'),
  'sysFoot': require('../../../static/img/syscom/bkg-foot.png'),
  'homeSummary': require('../../../static/img/syscom/bkg-com.png'),
  'aboutUsHead': require('../../../static/img/syscom/about-us.png'),
  'enAboutUsHead': require('../../../static/img/syscom/about-us-en.png'),
  productModule: {
    'banner': require('../../../static/img/product/banner.jpg')
  },
  footerModule: {
    'sysFoot': require('../../../static/img/syscom/bkg-foot.png'),
    'police': require('../../../static/img/footer/police.png'),
    'wxPublic': require('../../../static/img/footer/weixin.jpg'), // 微信公众号
    'phone': require('../../../static/img/footer/phone.png'),
    'zipcode': require('../../../static/img/footer/mail2.png'),
    'email': require('../../../static/img/footer/mail.png'),
    'location': require('../../../static/img/footer/phone.png')
  },
  homeDigitalPlatform: {

  }
}
export default IMGSTATION



// WEBPACK FOOTER //
// ./src/common/util/imgStation.js